import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, IconButton, Typography } from "@mui/material";
import { CSSProperties, useRef } from "react";
import { ThreadContext } from "../contexts/ThreadContext.js";
import { PostsList } from "./PostsList.js";
import { ThreadDocumentsList } from "./ThreadDocuments.js";
import { Row } from "../misc/Row.js";
import { FlatAccordion } from "../misc/FlatAccordion";

export function Thread({
  showToggleButton,
  handleDrawerToggle,
  open,
  style,
  threadId,
}: {
  handleDrawerToggle?: () => void;
  open?: boolean;
  showToggleButton?: boolean;
  style?: CSSProperties;
  threadId: string;
}) {
  const postsRef = useRef<{ showForm: () => void }>(null);
  const documentRef = useRef<{ showForm: () => void }>(null);

  return (
    <ThreadContext.Provider value={{ threadId }}>
      {showToggleButton && (
        <Row sx={{ alignItems: "center", justifyContent: "space-between", mb: "8px" }}>
          <Typography sx={{ flex: 1, fontWeight: "bold", fontSize: 15 }}>Notizen & Dokumente</Typography>
          <IconButton onClick={() => handleDrawerToggle?.()}>
            <ExpandMoreIcon style={{ transform: open ? "rotate(0deg)" : "rotate(180deg)" }} />
          </IconButton>
        </Row>
      )}
      <FlatAccordion buttonRef={documentRef} title="Dokumente" expandIconPosition="left">
        <ThreadDocumentsList ref={documentRef} style={style} />
      </FlatAccordion>
      <Divider />
      <FlatAccordion defaultExpanded buttonRef={postsRef} title="Notizen" expandIconPosition="left">
        <PostsList ref={postsRef} style={style} />
      </FlatAccordion>
    </ThreadContext.Provider>
  );
}
